import styled from '@emotion/styled';

export const StyledNameText = styled('div')({
  color: 'inherit',
  fontSize: '0.875rem',
  fontWeight: 600,
  lineHeight: 1.3,
});

export const StyledDescriptionText = styled('div')({
  color: '#9CA3AF',
  fontSize: '0.75rem',
  lineHeight: 1.3,
});

export const StyledMutedMonospaceText = styled('span')({
  color: '#9CA3AF',
  fontFamily: 'monospace',
  fontSize: '0.8125rem',
});

export const StyledStatusLabel = styled('span')({
  fontSize: '0.875rem',
  fontWeight: 500,
  textTransform: 'capitalize',
});

export const StyledRightAlignedCell = styled('div')({
  textAlign: 'right',
});

export const StyledUpdatedAtText = styled('span')({
  color: '#9CA3AF',
  fontSize: '0.75rem',
  whiteSpace: 'nowrap',
});

export const StyledActionLinkContainer = styled('div')({
  '& a': {
    display: 'inline-flex',
    textDecoration: 'none',
  },
});

export const StyledStatusSwitchWrap = styled('div')(() => ({
  '& .mantine-Switch-root': {
    cursor: 'pointer',
  },
  '& .mantine-Switch-body': {
    cursor: 'pointer',
  },
  '& .mantine-Switch-track': {
    cursor: 'pointer',
  },
  '& .mantine-Switch-thumb': {
    cursor: 'pointer',
  },
  '& .mantine-Switch-label': {
    cursor: 'pointer',
  },
}));
